<template>
  <div class="acomodar">

    <CitaMedica/>
  
  </div>
</template>


<script>
import CitaMedica from '@/components/Enfermeria/CitaMedica.vue';
export default {
  name: "CopiasCitaMedica",
  components:{
    CitaMedica
  },

  data() {
    return {
      

    };
  },

  mounted() {
   

  },

  

  
  

  
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  /* margin-right: 0.5rem !important; */
  margin-top: 9px;
  margin-bottom: 9px;
  margin-left: 0.5%;
  margin-right: 0.5%;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
}


</style>
